import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import AccountCurrentBonus from 'AccountCurrentBonus.js';
import AccountQueueBonus from 'AccountQueueBonus.js';
import AccountHistoricalBonus from 'AccountHistoricalBonus.js';

const AccountBonusRoute = (props) => {
  return (
    <Switch>
      <Route
        exact
        path={`${props.match.path}/all`}
        render={(props) => (
          <div>
            <AccountCurrentBonus {...props} />
            <AccountHistoricalBonus {...props} />
          </div>
        )}
      />
      <Route path={`${props.match.path}/current-bonus`} component={AccountCurrentBonus} />
      <Route path={`${props.match.path}/queue-bonus`} component={AccountQueueBonus} />
      <Route path={`${props.match.path}/historical-bonus`} component={AccountHistoricalBonus} />
      <Redirect to={`${props.match.path}/all`} />
    </Switch>
  );
};

export default AccountBonusRoute;
